<div fxLayout="column" fxFlex="100" fxLayoutGap="20px">
  <div class="container" fxLayout="column" fxFlex="100" fxLayoutGap="20px">
    <h1 class="header">{{ 'Order.Orders' | translate }}</h1>
    <div class="content-card">
      <mat-tab-group (selectedTabChange)="onTabChanged($event)" mat-stretch-tabs="false">
        @for (link of filteredNavigation; track link) {
          <mat-tab [label]="link.labelName">
          </mat-tab>
        }
      </mat-tab-group>
    </div>

    <div class="views-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
